function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0 and the Server Side Public License, v 1; you may not use this file except
 * in compliance with, at your election, the Elastic License 2.0 or the Server
 * Side Public License, v 1.
 */
import { css } from '@emotion/react';
import { logicalCSS, logicalTextAlignCSS, logicalSide } from '../../global_styling';

var _ref = process.env.NODE_ENV === "production" ? {
  name: "gacnmc-allowFullScreen",
  styles: "&:hover [class*='euiImageCaption']{text-decoration:underline;};label:allowFullScreen;"
} : {
  name: "gacnmc-allowFullScreen",
  styles: "&:hover [class*='euiImageCaption']{text-decoration:underline;};label:allowFullScreen;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

export var euiImageWrapperStyles = function euiImageWrapperStyles(euiThemeContext) {
  var euiTheme = euiThemeContext.euiTheme;
  return {
    // Base
    euiImageWrapper: /*#__PURE__*/css("display:inline-block;", logicalCSS('max-width', '100%'), " ", logicalTextAlignCSS('center'), ";line-height:0;flex-shrink:0;;label:euiImageWrapper;"),
    allowFullScreen: _ref,
    // Margins
    s: /*#__PURE__*/css("margin:", euiTheme.size.s, ";;label:s;"),
    m: /*#__PURE__*/css("margin:", euiTheme.size.base, ";;label:m;"),
    l: /*#__PURE__*/css("margin:", euiTheme.size.l, ";;label:l;"),
    xl: /*#__PURE__*/css("margin:", euiTheme.size.xl, ";;label:xl;"),
    // Floats
    // 1: Logical properties/values in `float` is currently not yet supported by all browsers w/o flags
    // @see https://caniuse.com/mdn-css_properties_float_flow_relative_values for when we can remove left/right fallbacks
    left: /*#__PURE__*/css("@media only screen and (min-width: ", euiTheme.breakpoint.m, "px){float:left;float:", logicalSide.left, ";", logicalCSS('margin-left', '0'), ";", logicalCSS('margin-top', '0'), ";};label:left;"),
    right: /*#__PURE__*/css("@media only screen and (min-width: ", euiTheme.breakpoint.m, "px){float:right;float:", logicalSide.right, ";", logicalCSS('margin-right', '0'), ";", logicalCSS('margin-top', '0'), ";};label:right;"),
    // Sizes
    fullWidth: /*#__PURE__*/css(logicalCSS('width', '100%'), ";;label:fullWidth;")
  };
};